import { render, staticRenderFns } from "./DimensionsColumn.vue?vue&type=template&id=5f2a92ac&"
import script from "./DimensionsColumn.vue?vue&type=script&lang=js&"
export * from "./DimensionsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports